/* Presentation tools only: product forms, calculated quantities and checkout stay native. */
(() => {
  'use strict';
  const tools = document.getElementById('StudioTools');
  if (!tools) return;
  const key = 'sim-studio-saved-v1';
  const preview = document.getElementById('StudioPreview');
  const savedDialog = document.getElementById('StudioSaved');
  let saved = [];
  let opener;
  const valid = item => item && /^\d+$/.test(String(item.id)) && typeof item.title === 'string' && typeof item.url === 'string' && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^?#]+(?:\?[^#]*)?$/i.test(item.url);
  try { saved = JSON.parse(localStorage.getItem(key) || '[]'); } catch (_) { saved = []; }
  saved = Array.isArray(saved) ? saved.filter(valid).slice(0,60) : [];
  function sync() {
    document.querySelectorAll('[data-studio-product]').forEach(card => {
      const button = card.querySelector('[data-studio-save]');
      const isSaved = saved.some(item => item.id === card.dataset.id);
      if (button && button.getAttribute('aria-pressed') !== String(isSaved)) {
        button.setAttribute('aria-pressed', String(isSaved));
        button.setAttribute('aria-label', `${isSaved ? tools.dataset.saved : tools.dataset.save}: ${card.dataset.title}`);
      }
    });
    document.querySelectorAll('[data-studio-count]').forEach(count => {
      count.textContent = String(saved.length);
      count.hidden = saved.length === 0;
    });
  }
  function persist() { try { localStorage.setItem(key, JSON.stringify(saved)); } catch (_) {} sync(); }
  function open(dialog, trigger) {
    opener = trigger;
    if (!dialog.open) dialog.showModal();
  }
  function renderSaved() {
    const list = savedDialog.querySelector('.studio-saved-list');
    list.replaceChildren();
    savedDialog.querySelector('.studio-saved-empty').hidden = saved.length > 0;
    saved.forEach(item => {
      const li = document.createElement('li');
      if (item.image && /^https:\/\//.test(item.image)) {
        const img = document.createElement('img');
        img.src = item.image; img.alt = ''; img.width = 72; img.height = 72; img.loading = 'lazy'; li.append(img);
      }
      const a = document.createElement('a');
      // Resolve saved products in the language currently selected by the customer.
      const handle = item.url.split('/products/')[1];
      a.href = `${window.Shopify?.routes?.root || '/'}products/${handle}`;
      a.textContent = item.title;
      const remove = document.createElement('button');
      remove.type = 'button'; remove.textContent = '×'; remove.dataset.studioRemove = item.id;
      remove.setAttribute('aria-label', `${tools.dataset.saved}: ${item.title}`);
      li.append(a, remove); list.append(li);
    });
  }
  document.addEventListener('click', event => {
    const target = event.target.closest('button');
    if (!target) return;
    if (target.hasAttribute('data-studio-save')) {
      const card = target.closest('[data-studio-product]');
      const index = saved.findIndex(item => item.id === card.dataset.id);
      if (index >= 0) saved.splice(index,1);
      else if (saved.length < 60) {
        const item = {id:card.dataset.id,title:card.dataset.title,url:card.dataset.url,image:card.dataset.image || ''};
        if (valid(item)) saved.push(item);
      }
      persist();
    } else if (target.hasAttribute('data-studio-preview')) {
      const card = target.closest('[data-studio-product]');
      const wrapper = card.closest('.product-card-wrapper');
      preview.querySelector('h2').textContent = card.dataset.title;
      const media = preview.querySelector('.studio-preview-media'); media.replaceChildren();
      if (card.dataset.image) { const img = document.createElement('img'); img.src = card.dataset.image; img.alt = card.dataset.title; img.width = 900; img.height = 900; media.append(img); }
      const price = preview.querySelector('.studio-preview-price'); price.replaceChildren();
      const currentPrice = wrapper.querySelector('.card-information .price');
      if (currentPrice) { const clone = currentPrice.cloneNode(true); clone.removeAttribute('id'); clone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id')); price.append(clone); }
      preview.querySelector('.studio-preview-link').href = card.dataset.url;
      open(preview,target);
    } else if (target.hasAttribute('data-studio-saved')) {
      renderSaved(); open(savedDialog,target);
    } else if (target.hasAttribute('data-studio-close')) {
      target.closest('dialog').close();
    } else if (target.dataset.studioRemove) {
      const previous = saved.findIndex(item => item.id === target.dataset.studioRemove);
      saved = saved.filter(item => item.id !== target.dataset.studioRemove); persist(); renderSaved();
      const buttons = savedDialog.querySelectorAll('[data-studio-remove]');
      (buttons[Math.min(previous,buttons.length - 1)] || savedDialog.querySelector('[data-studio-close]')).focus();
    } else if (target.dataset.studioGrid) {
      const columns = target.dataset.studioGrid;
      try { localStorage.setItem('sim-studio-columns', columns); } catch (_) {}
      setGrid(columns);
    }
  });
  [preview,savedDialog].forEach(dialog => {
    dialog.addEventListener('click',event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close',() => { if (opener?.isConnected) opener.focus(); });
  });
  function setGrid(columns) {
    const value = columns === '4' ? '4' : '3';
    document.body.style.setProperty('--studio-columns',value);
    document.querySelectorAll('[data-studio-grid]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.studioGrid === value)));
  }
  try { setGrid(localStorage.getItem('sim-studio-columns')); } catch (_) { setGrid('3'); }
  let syncFrame = 0;
  const grid = document.getElementById('ProductGridContainer');
  if (grid) new MutationObserver(() => { if (!syncFrame) syncFrame = requestAnimationFrame(() => { syncFrame = 0; sync(); }); }).observe(grid,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',sync);
  window.addEventListener('storage',event => { if (event.key === key) { try { const next = JSON.parse(event.newValue || '[]'); if (Array.isArray(next)) { saved = next.filter(valid).slice(0,60); sync(); if (savedDialog.open) renderSaved(); } } catch (_) {} } });
  sync();
})();
